import { ReactNode } from 'react';
import classNames from 'classnames';

import { Classes } from 'types/Classes';
import Typography from '@components/atoms/Typography';
import createStyleVariables from 'utils/createStyleVariables';

import classes from './Tooltip.module.scss';

type Props = {
  title: ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  maxWidth?: number;
  classes?: Classes<'root' | 'trigger' | 'tooltip'>;
  children: ReactNode;
};

const Tooltip = ({
  title,
  placement = 'right',
  maxWidth = 300,
  classes: customClasses,
  children,
}: Props): JSX.Element => (
  <div className={classNames(classes.wrapper, customClasses?.root)}>
    <div className={classNames(classes.trigger, customClasses?.trigger)}>{children}</div>
    <Typography
      variant="caption2"
      className={classNames(classes.tooltip, classes[placement], customClasses?.tooltip)}
      style={createStyleVariables({ tooltipMaxWidth: `${maxWidth}px` })}
    >
      {title}
    </Typography>
  </div>
);

export default Tooltip;
